









































































































import { Component, Mixins } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import UtilMixin from "@/mixins/utilMixin";
import RulesMixin from "#/mixins/rulesMixin";
import { Choice } from "@/types";
import { ListIndex } from "@/views/aivnplan/types";
import AppAuthButton from "@/components/admin_common/AppAuthButton.vue";
import { AiVnplanSetting, DefaultAiVnplanSetting } from "#/model/admin/index";

@Component({
  components: {
    AppAuthButton,
  },
})
/** 計画書自動作成 インデックス設定 */
export default class IndexConfig extends Mixins(
  AxiosMixin,
  UtilMixin,
  RulesMixin
) {
  /** 変数 */

  /** フィルター用キーワード */
  private searchKeyword = "";

  /** 1ページあたりの表示件数 */
  private itemPerPage = 25;

  /** 表の現在のページ数 */
  private pageNo = 1;

  /** 作成済みインデックス情報 */
  private indices: ListIndex[] = [];

  /** データテーブル用ヘッダー */
  private headers = [
    {
      text: "データセット名",
      align: "start",
      value: "dataset_name",
      filterable: true,
      sortable: false,
    },
    {
      text: "対象年月",
      align: "start",
      value: "yearmonth_str",
      filterable: true,
      sortable: true,
    },
    {
      text: "処理件数",
      align: "start",
      value: "processed_count",
      filterable: false,
      sortable: true,
    },
    {
      text: "作成日時",
      align: "start",
      value: "created_at_str",
      filterable: false,
      sortable: true,
    },
    {
      text: "有効",
      align: "start",
      value: "is_valid",
      filterable: false,
      sortable: true,
    },
    {
      text: "",
      value: "actions",
      sortable: false,
      align: "end",
    },
  ];

  /** 計画書自動作成設定 */
  private setting: AiVnplanSetting = DefaultAiVnplanSetting();

  /** インデックス期間指定選択肢 */
  private conditionYearmonthChoice: Choice[] = [
    { text: "未使用", value: 0 },
    { text: "全期間", value: 1 },
    { text: "直近3ヶ月", value: 2 },
    { text: "直近6ヶ月", value: 3 },
  ];

  /** 関数 */

  async created() {
    this.fetch();
    this.fetchSetting();
  }

  /** 取得 */
  private fetch() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/index/form/get",
      {},
      async (res) => {
        this.indices = res.data.indices;
      }
    );
  }

  /** インデックス削除 */
  private async deleteIndex(indexId: number) {
    if (!(await this.$openConfirm("インデックスを削除しますか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/index/delete",
      { id: indexId },
      async () => {
        await this.$openAlert("削除しました。");
        this.fetch();
      }
    );
  }

  /** インデックス有効/無効切り替え */
  private async switchIndexValid(index: ListIndex) {
    const dist = index.is_valid == 1 ? "有効" : "無効";

    if (!(await this.$openConfirm(`対象のインデックスを${dist}にしますか？`))) {
      index.is_valid ^= 1;
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/index/valid/switch",
      { index: index },
      async () => {
        await this.$openAlert(`対象のインデックスを${dist}にしました。`);
        this.fetch();
      }
    );
  }

  /** 自動作成設定を取得 */
  private fetchSetting() {
    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/setting/get",
      {},
      async (res) => {
        this.setting = res.data.ai_vnplan_setting;
      }
    );
  }

  /** 自動作成設定（インデックス期間指定）保存 */
  private async saveSetting() {
    if (!(await this.$openConfirm("保存しますか？"))) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/aivnplan/setting/save",
      { ai_vnplan_setting: this.setting, need_index_update: 1 },
      async () => {
        this.fetchSetting();
        this.$openAlert("保存しました。");
      }
    );
  }

  /** インデックス自動作成条件設定画面へ遷移 */
  private moveToIndexBatchConfigPage() {
    this.$router.push({
      path: "/ai-vnplan/index/batch-config",
    });
  }

  /** インデックス作成画面へ遷移 */
  private moveToIndexCreatePage() {
    this.$router.push({
      path: "/ai-vnplan/index/create",
    });
  }

  /** 表のページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }
}
